<div class="country-affiliation-container">
  <div class="header">
    <div>
    <div class="title-with-icon">
      <img routerLink="/settings" src="assets/images/leftArrow.png"/>
      <h3>Country Affiliation</h3>
    </div>
      <p style="margin-left: 28px;">Manage your country affiliation and related information</p>
    </div>
    <div class="btn-with-icon">
      <button class="add-country-btn" (click)="openAddCountryDialog()" *ngIf="!shouldHideAddButton()">
        <i class="fa fa-plus"></i> Add Country
      </button> 
      <!-- <i class="bi bi-info-circle"></i> -->
    </div>
  </div>
  <hr />

  <!--country flag-->
  <div class="country-list">
    <div class="country-tab" *ngFor="let item of citizen" [class.active]="selectedCountry === item"
      (click)="selectedCountry = item;getLog();">
      <h4 class="country-name">{{ item.country }}</h4>
      <span class="country-role">{{ getCountryRole(item.index) }}</span>
      <div class="flag-wrapper">
        <img [src]="getFlagUrl(item.country)" [alt]="item.country + ' Flag'" class="flag-img"
          *ngIf="getFlagUrl(item.country)" />
      </div>
      <i class="bi bi-chevron-down downArr" *ngIf="selectedCountry === item"></i>
    </div>
  </div>
  <!--country flag-->

  <div *ngIf="selectedCountry" class="card">
    <hr />
    <div class="details-grid">
      <div class="info-block">
        <img class="countAffImg" src="assets/images/affCA.svg" />
        <div>
          <label>Affiliation Type</label>
          <!-- <p>{{ selectedCountry.affiliation_type || 'Not provided' }}</p> -->
          <p>{{ mapAffiliationType(selectedCountry?.affiliation_type) }}</p>
        </div>
      </div>
      <div class="info-block">
        <img class="countAffImg" src="assets/images/homeCA.svg" />
        <div>
          <label>Home Address</label>
          <p>{{ selectedCountry.home_address || 'Not provided' }}</p>
        </div>
      </div>
      <div class="info-block">
        <img style="width: 12px" src="assets/images/mobileCA.svg" />
        <div>
          <label>Mobile Number</label>
          <p>{{ selectedCountry.mobile_phone || 'Not provided' }}</p>
        </div>
      </div>
      <div class="info-block">
        <img class="countAffImg" src="assets/images/workaddressCA.svg" />
        <div>
          <label>Work Address</label>
          <p>{{ selectedCountry.work_address || 'Not provided' }}</p>
        </div>
      </div>
      <div class="info-block">
        <img class="countAffImg" src="assets/images/workphoneCA.svg" />
        <div>
          <label>Work Number</label>
          <p>{{ selectedCountry.work_phone || 'Not provided' }}</p>
        </div>
      </div>
      <div class="info-block" style="gap: 6px !important;">
        <img class="countAffImg" src="assets/images/alternumberCA.svg" />
        <div>
          <label>Alternate Number</label>
          <p>{{ selectedCountry.alt_phone || 'Not provided' }}</p>
        </div>
      </div>
    </div>
    <hr />

    <div class="footer" *ngIf="selectedCountry">
      <!-- <button class="remove-btn" *ngIf="selectedCountry && selectedCountry.index !== 'citizen_primary'" (click)="confirmDeleteCountry(selectedCountry)">Remove Country</button> -->
      <button class="remove-btn" (click)="confirmDeleteCountry(selectedCountry)"
        [disabled]="selectedCountry.index === 'citizen_primary'">Remove Country</button>
      <button class="edit-btn" (click)="openAddCountryDialog(selectedCountry)">Edit Details</button>
    </div>
  </div>

  <!--delete conf dialog-->
  <app-confirmation-dialog [visible]="showConfirmDialog"
    [message]="'Are you sure want to delete this Country Affiliation?'" (confirm)="handleConfirmDelete()"
    (cancel)="resetDeleteDialog()">
  </app-confirmation-dialog>
  <!--delete conf dialog-->

</div>